import { render, staticRenderFns } from "./ConsumptionDataExchangeAsko.vue?vue&type=template&id=37bebb16&lang=pug&"
import script from "./ConsumptionDataExchangeAsko.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangeAsko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports